import { WebApiService, HttpRequestOptions } from '../../../plugins/webApiService';
import AppSettings from '@/appSettings';

export interface SpeechResult { voiceFileId: string; femaleUrl: string; maleUrl: string; generated: number; }
export interface SpeechStatus {
  isRunning: boolean;
  isCancelled: boolean;
  started: string | null;
  finished: string | null;
  total: number;
  processed: number;
  generated: number;
  failed: number;
  errors: any[];
}
export function speechFileUrl(url: string): string {
  if (!url || /^(https?:|blob:|data:)/i.test(url)) return url;
  return `${AppSettings.filesBaseUrl}/${url.replace(/^\/+/, '')}`;
}
export function speechErrorMessage(error: any): string {
  return error && (error.message || error.ErrorMessage) || 'Не удалось обратиться к сервису озвучки. Повторите позже.';
}

export default class SpeechService {
  constructor(private api: WebApiService) {}
  async generateAsync(voiceFileId: string, force: boolean = false, options: HttpRequestOptions = {}): Promise<SpeechResult> {
    const result = await this.api.requestHttpAsync<SpeechResult>('/api/speech/generate', 'POST', { voiceFileId, force }, { timeoutMs: 60000, ...options });
    return { ...result, femaleUrl: speechFileUrl(result.femaleUrl), maleUrl: speechFileUrl(result.maleUrl) };
  }
  generateAllAsync(request: { langCodes?: string[]; affirmationIds?: number[]; force?: boolean }): Promise<SpeechStatus> {
    return this.api.requestHttpAsync('/api/speech/generate-all', 'POST', request);
  }
  getStatusAsync(): Promise<SpeechStatus> { return this.api.requestHttpAsync('/api/speech/generate-all/status'); }
  cancelAsync(): Promise<void> { return this.api.requestHttpAsync('/api/speech/generate-all/cancel', 'POST'); }
}
